export const AUTH_TOKEN = 'authToken';
export const GOOGLE_TOKEN = 'googleToken';
export const APPLE_CODE = 'appleCode';
export const CAMPAIGN = 'campaign';
export const INTERNAL_ANALYTICS = 'iac';
export const INTERNAL_ANALYTICS_EXTERNAL_UUID = 'iac-id';
export const SHOWN_PROFILE_PROGRESS = 'shProProgress';
export const SIGN_UP_INFO = 'signUpAccount';
export const COOKIE_CONSENT = 'cookie_consent';
export const DISCOVERY_CACHE = 'discoveryCache';
export const FIREBASE_TOKEN = 'fireToken';
export const CODE_COUNTDOWN_STARTED_AT = 'codeCountdownStartedAt';
export const CODE_TRIES_LEFT = 'codeTriesLeft';
export const USER_INFO_STEP = 'userInfoStep';
export const MANUAL_AND_APP_LANGUAGE = 'manualAppLang';
export const AUTO_REDIRECTED_TO_BETTER_LANGUAGE = 'autoRedirectedToLang';
// language overrides comes from our TMS
export const TMS_OVERRIDES = 'tmsOverrides';
